import { render, staticRenderFns } from "./Peso.vue?vue&type=template&id=a187b230&lang=true"
import script from "./Peso.vue?vue&type=script&lang=js"
export * from "./Peso.vue?vue&type=script&lang=js"
import style0 from "./Peso.vue?vue&type=style&index=0&id=a187b230&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports